import { useState } from "react";
import { BarChart3, Users, MessageSquareQuote, Send, Search, LogOut } from "lucide-react";
import { api } from "../../lib/api";
import { Logo } from "../Logo";
import { AnalyticsTab } from "./AnalyticsTab";
import { EnquiriesTab } from "./EnquiriesTab";
import { TestimonialsTab } from "./TestimonialsTab";
import { FollowUpsTab } from "./FollowUpsTab";
import { SeoTab } from "./SeoTab";

const TABS = [
  { id: "analytics", label: "Analytics", icon: BarChart3 },
  { id: "enquiries", label: "Enquiries", icon: Users },
  { id: "testimonials", label: "Testimonials", icon: MessageSquareQuote },
  { id: "followups", label: "Follow Us", icon: Send },
  { id: "seo", label: "SEO", icon: Search },
];

export function AdminShell({ onLoggedOut }) {
  const [tab, setTab] = useState("analytics");

  const logout = async () => {
    await api.post("/admin/logout").catch(() => {});
    onLoggedOut();
  };

  return (
    <div className="min-h-screen bg-[#050A15] flex" data-testid="admin-shell">
      <aside className="w-64 shrink-0 border-r border-[#d4a840]/15 bg-[#03060d] flex flex-col">
        <div className="px-6 py-6 border-b border-[#d4a840]/15">
          <Logo size={48} />
          <div className="kb-label mt-3">Admin Dashboard</div>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1">
          {TABS.map((t) => {
            const Icon = t.icon;
            const active = tab === t.id;
            return (
              <button
                key={t.id}
                type="button"
                onClick={() => setTab(t.id)}
                data-testid={`admin-tab-${t.id}`}
                className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-colors ${
                  active ? "bg-[#d4a840]/15 text-[#d4a840] border border-[#d4a840]/30" : "text-white/70 hover:bg-white/5 hover:text-white"
                }`}
              >
                <Icon size={17} />
                {t.label}
              </button>
            );
          })}
        </nav>
        <div className="px-3 py-4 border-t border-[#d4a840]/15">
          <button
            type="button"
            onClick={logout}
            data-testid="admin-logout"
            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-white/60 hover:bg-white/5 hover:text-white transition-colors"
          >
            <LogOut size={17} />
            Log out
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0 overflow-y-auto">
        <div className="max-w-6xl mx-auto px-8 py-10">
          {tab === "analytics" && <AnalyticsTab />}
          {tab === "enquiries" && <EnquiriesTab />}
          {tab === "testimonials" && <TestimonialsTab />}
          {tab === "followups" && <FollowUpsTab />}
          {tab === "seo" && <SeoTab />}
        </div>
      </main>
    </div>
  );
}
